import { get } from 'axios'

export default {
    actions: {
        async getObjects(ctx, params = {}) {
            if (ctx.state.objectsListLoaded) return Promise.resolve(ctx.state.objects)
            ctx.commit('updateLoadStatus', false)

            console.time('Load objects time')

            const request = await get(
                '/api/objects/list',
                {
                    headers: params.headers,
                    params: params
                }
            )

            const label = `[vuex] [global] Get objects [${request.data.Data.length}]`;
            console.groupCollapsed(label);
            console.info(request.data.Data);
            console.timeEnd('Load objects time')
            console.groupEnd(label);


            ctx.commit('updateObjects', request.data.Data)
            ctx.commit('updateLoadStatus', true)
        }
    },
    mutations: {
        updateObjects(state, objects) {
            state.objects = objects
        },
        updateLoadStatus(state, objectsListLoaded) {
            state.objectsListLoaded = objectsListLoaded
        },
    },
    state: {
        objects: [],
        objectsListLoaded: false,
    },
    getters: {
        myObjects(state) {
            return state.objects
        },
        myObjectsListLoaded(state) {
            return state.objectsListLoaded
        },
        resolveObject(state) {
            return ({ object_id, ObjectID }) => {
                return state.objects.find(o => o.ObjectID == (object_id || ObjectID))
            }
        }
    },
}